import { IOrganization } from '#backend/common/organization-types';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { EnhancedLoadingService } from '../../../shared/services/enhanced-loading.service';
import { SmartOrpcClientService } from '../../../shared/services/smart-orpc-client.service';
import { OrganizationFormComponent } from '../organization-form/organization-form.component';
import { SnackbarService } from '../../../shared/services/snackbar.service';

@Component({
  selector: 'app-create-organization',
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    OrganizationFormComponent,
  ],
  templateUrl: './create-organization.component.html',
  styleUrl: './create-organization.component.scss',
})
export class CreateOrganizationComponent {
  orpc = inject(SmartOrpcClientService);
  router = inject(Router);
  snackBarService = inject(SnackbarService);

  isLoading = inject(EnhancedLoadingService).isLoad$;

  async onSubmit({ name, cnpj }: Pick<IOrganization, 'name' | 'cnpj'>) {
    const {
      error,
      data: orgId,
      isDefined,
    } = await this.orpc.safeClient.organization.create(
      { name, cnpj },
      // Trata as mensagens de erro manualmente abaixo (CONFLICT tem mensagem própria)
      { context: { suppressErrorAlert: true } },
    );

    if (error && !isDefined) {
      this.snackBarService.handleOrpcError(error);
    } else if (error && isDefined) {
      if (error.code === 'CONFLICT') {
        this.snackBarService.alert(error.message);
      }
    } else {
      this.snackBarService.alert('Cliente cadastrado com sucesso!');

      this.router.navigate(['admin', 'organizations', 'details', orgId]);
    }
  }
}
